import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { LoginForm } from "./LoginForm";
import { useAuth } from "@/utils/auth";
import Cookies from "js-cookie";
export function Auth() {
  const { signinWithEmail, signupWithEmail, user } = useAuth();
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cookie = Cookies.get("token");
  const signUp = ({ email, pass }) => {
    signupWithEmail(email, pass).catch((error) => {
      toast({
        title: "An error occurred.",
        description: error.message,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    });
  };
  const signIn = ({ email, pass }) => {
    signinWithEmail(email, pass).catch((error) => {
      toast({
        title: "An error occurred.",
        description: error.message,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    });
  };
  return (
    <Modal isOpen={cookie !== undefined ? false : true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <Tabs variant="line" align="center" isFitted>
            <TabList>
              <Tab>Sign In</Tab>
              <Tab>Sign Up</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <LoginForm type="Sign in" onSubmit={signIn} />
              </TabPanel>
              <TabPanel>
                <LoginForm type="Sign up" onSubmit={signUp} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
